import * as XLSX from 'xlsx'
import React, { useRef, useState } from 'react'
import { PrimaryCta } from 'components'
import { useDispatch } from 'react-redux'
import { successSnack, errorSnack } from 'features'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileExcel } from '@fortawesome/free-solid-svg-icons'

export function LazyReportExport(_props) {
  const {
    query,
    queryParams = {},
    columns = [],
    title = 'export',
    fileName = 'reporte',
    preExport = null,
    dataFormat = 'json',
    reportHeader = [],
    lazy = false,
    children,
    ...rest
  } = _props
  const [startExport, setStartExport] = useState(false)
  const xlsBookRef = useRef(null)
  const xlsSheetRef = useRef(null)

  const [queryFunction, { isLoading }] = query()

  const handleRequestReport = React.useCallback(() => {
    queryFunction({
      ...queryParams,
    })
      .unwrap()
      .then((response) => {
        let data = preExport ? preExport(response) : response
        xlsBookRef.current = XLSX.utils.book_new()
        xlsSheetRef.current = XLSX.utils.aoa_to_sheet(reportHeader)
        if (dataFormat === 'json') {
          let reportData = prepareExportDataFromJson({
            rows: data.rows,
            columns,
          })
          XLSX.utils.sheet_add_json(xlsSheetRef.current, reportData, {
            origin: -1,
            cellDates: true,
          })
        } else {
          XLSX.utils.sheet_add_aoa(xlsSheetRef.current, data, { origin: -1 })
        }
        try {
          XLSX.utils.book_append_sheet(
            xlsBookRef.current,
            xlsSheetRef.current,
            title
          )
          XLSX.writeFile(xlsBookRef.current, `${fileName}.xlsx`)
        } catch (error) {
        }
        setStartExport(false)
      })
  }, [queryParams])

  return (
    <PrimaryCta
      isSubmitting={isLoading}
      startIcon={<FontAwesomeIcon icon={faFileExcel} />}
      submittingLabel="Exportando"
      onClick={handleRequestReport}
      {...rest}
    >
      {children ? children : 'Exportar'}
    </PrimaryCta>
  )
}

function processCell({ value, type = null, format = null }) {
  if (type === 'date') {
    return new Date(value)
  } else {
    return value
  }
}
function processSumRow({ accumulator, columnName, value, type }) {
  if (typeof type === 'string') {
    accumulator[columnName] = type
  } else if (type === true) {
    accumulator[columnName] = accumulator[columnName]
      ? accumulator[columnName] + value
      : value
  }
  return accumulator
}

function prepareExportDataFromJson({ rows, columns }) {
  const resultData = rows.reduce(
    (acc, rawRow) => {
      let row = {}
      columns.forEach((column) => {
        try {
          row[column.headerName] = processCell({
            value: column?.reportFormat
              ? column?.reportFormat(rawRow)
              : rawRow[column.field],
            type: column?.reportType,
          })
          acc.sumRow = processSumRow({
            accumulator: acc.sumRow,
            columnName: column.headerName,
            value: rawRow[column.field],
            type: column?.reportSum,
          })
        } catch (error) {
        }
      })
      acc.dataRows.push(row)
      return acc
    },
    { dataRows: [], sumRow: {} }
  )
  return [...resultData.dataRows, resultData.sumRow]
}

function prepareExportDataFromArrayofArrays({ rows, columns }) {
  const resultData = rows.reduce(
    (acc, rawRow) => {
      let row = {}
      columns.forEach((column) => {
        try {
          row[column.headerName] = processCell({
            value: rawRow[column.field],
            type: column?.reportType,
            format: column?.reportFormat,
          })
          acc.sumRow = processSumRow({
            accumulator: acc.sumRow,
            columnName: column.headerName,
            value: rawRow[column.field],
            type: column?.reportSum,
          })
        } catch (error) {
        }
      })
      acc.dataRows.push(row)
      return acc
    },
    { dataRows: [], sumRow: {} }
  )
  return [...resultData.dataRows, resultData.sumRow]
}
